import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=5214af74&scoped=true"
import script from "./Direct.vue?vue&type=script&lang=js"
export * from "./Direct.vue?vue&type=script&lang=js"
import style0 from "./Direct.vue?vue&type=style&index=0&id=5214af74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214af74",
  null
  
)

export default component.exports